export const EXTERNAL_ENDPOINT_TEST = "https://www.gstatic.com/generate_204"; //ep wystawiany przez google
export const LATENCY_CS_ENDPOINT_MID = 850;
export const LATENCY_CS_ENDPOINT_GOOD = 450;

export type NetworkStatus = "good" | "slow" | "offline" | "unknown";
